module.exports = __webpack_public_path__ + "static/harald@2x-824dc7ee8b6c0545fc56d8e9ed5490d1.jpg";